import type { SupStoredOverlay } from "@/store/types";
import React from "react";

import Web3PiggyHarvest from "@/components/Web3/Piggy/Harvest";
import Web3PiggyWithdraw from "@/components/Web3/Piggy/Withdraw";
import Web3PiggyDeposit from "@/components/Web3/Piggy/Deposit";

import { twMerge } from "tailwind-merge";

interface LayoutSidebarModeClaimRewardsProps {
  className?: string;
  headerClassName?: string;
  mode: SupStoredOverlay;
}

export default function LayoutSidebarModePiggy({ className, headerClassName, mode }: LayoutSidebarModeClaimRewardsProps) {
  return (
    <div className={twMerge("relative flex h-full max-h-screen flex-col justify-start overflow-y-scroll p-6 pt-[60px]", className)}>
      {mode === "piggy-deposit" && <Web3PiggyDeposit headerClassName={headerClassName} />}
      {mode === "piggy-harvest" && <Web3PiggyHarvest headerClassName={headerClassName} />}
      {mode === "piggy-withdraw" && <Web3PiggyWithdraw headerClassName={headerClassName} />}
    </div>
  );
}
